export { default } from "./InsightsBanner";
